export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9126.a2b0c86c.jpg";